import React from "react";
import Navbar from "./components/Navbar/Navbar";
import { Routes, Route } from "react-router-dom";
import Tanfr from "./components/iframes/Tanfr";
import Eservices from "./components/iframes/Eservices";
import TanEntreprises from "./components/iframes/TanEntreprises";
import Applitan from "./components/Applitan/Applitan";
import Carto from "./components/iframes/Carto";
import Eservices2 from "./components/eservices/eServices";

const App = () => {
  return (
    <div className="app">
      <Navbar />
      <Routes>
        <Route path="/tablette/index.html" element={<Tanfr />} />
        <Route path="/tablette/eservices" element={<Eservices />} />
        <Route path="/tablette/tanentreprises" element={<TanEntreprises />} />
        <Route path="/tablette/applitan" element={<Applitan />} />
        <Route path="/tablette/carto" element={<Carto />} />
        <Route path="/tablette/eservices2" element={<Eservices2 />} />
      </Routes>
    </div>
  );
};

export default App;
